module.exports = __webpack_public_path__ + "static/media/automatedtimeattendancetracker.6567fc20.webp";